module.exports = "<div class=\"modal-header\">\n    <h4><i class=\"icon-info\"></i> {{ $ctrl.resolve.title || \"Information\" }}</h4>\n    <button class=\"close\" type=\"button\" ng-click=\"$ctrl.cancel()\">close</button>\n</div>\n<div class=\"modal-body break-word\">\n    <p style=\"max-height: 550px; overflow-y: auto\">{{ $ctrl.resolve.message }}</p>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn\" ng-click=\"$ctrl.cancel()\">{{ 'OK' | translate }}</button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app-modules/info-modal/info-modal.component.html
// module id = 1606
// module chunks = 7